
import Navigation from "./routes/Navigation.js";
function App() {
  return (
    <div>
      <Navigation/>
      {/* <h1 className="text-3xl font-bold underline">
        Hello world!
      </h1> */}
    </div>
  );
}

export default App;
